import React, { useEffect } from "react";
import {
  Table,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  UncontrolledDropdown,
  Row,
  Col,
  Progress,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButtonDropdown,
  Button,
  ButtonGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import styles from "../style.module.scss";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import { FormattedDate } from "react-intl";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { parseDate } from "../../../../utils";

const GridCustodian = ({ rows, loading, Flag }) => {
  return (
    <Table responsive>
      <thead>
        <tr>
          <th>#</th>
          <th>Custody</th>
          <th>Symbol</th>
          <th>Side</th>
          <th>Executed</th>
          <th>Trade</th>
          <th>Settlement</th>
          <th>Failing</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan={12}>
              <CircularProgress />
            </td>
          </tr>
        ) : (
          rows.map((d, i) => {
            const expected = new Date(d.TradeValueDate);
            const today = new Date();
            return (
              <tr key={i} className="bg-primary">
                <td className="">{d.TradeId}</td>
                <td className="text-nowrap">
                  {d.TradeBasicAccountId}
                  {" -  "}
                  {d.TradeBasicAccountName}
                </td>
                <td className="text-nowrap">{d.TradeAssetTicker}</td>
                <td className="">
                  <span className={"font-weight-bold bg-success " + styles.labelSide}>{d.TradeSide}</span>
                </td>
                <td className="">
                  {<FormattedNumber value={d.TradeQuantity} dataTypeDecimalName="quantity" />} @{" "}
                  {<FormattedNumber value={d.TradeAvgPrice} dataTypeDecimalName="price" />}
                </td>
                <td className="">
                  <FormattedDate value={d.TradeTradeDateTime} />
                </td>
                <td className="">
                  <FormattedDate value={parseDate(d.TradeValueDate)} />
                </td>
                <td className="">{d.TradeDaysDiferenceFailing} days</td>
                <td className="">{d.TradeStatus}</td>
              </tr>
            );
          })
        )}
      </tbody>
    </Table>
  );
};
export default GridCustodian;
